module.exports = __webpack_public_path__ + "static/2-Rabbit detail-527da413aa4ef324333911e2781b78dd.jpg";